// notification.service.ts
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject, timer } from 'rxjs';
import { switchMap, takeUntil, takeWhile } from 'rxjs/operators';

@Injectable()
export class NotificationService implements OnDestroy {
  private _unsubscribe$ = new Subject<void>();
  private notificationsSubject = new BehaviorSubject<INotification[]>([]);
  notifications$: Observable<INotification[]> =
    this.notificationsSubject.asObservable();

  constructor() {}

  showNotification(
    message: string,
    type?: NotificationType,
    ttl?: number,
  ): void {
    const notification: INotification = {
      message,
      type: type || NotificationType.INFO,
      ttl: ttl || 5000,
    };
    this.notificationsSubject.next([
      ...this.notificationsSubject.value,
      notification,
    ]);

    timer(notification.ttl)
      .pipe(
        takeUntil(this._unsubscribe$),
        switchMap(() => this.hideNotification(notification)),
        takeWhile(() => this.notificationsSubject.value.includes(notification)),
      )
      .subscribe();
  }

  private hideNotification(
    notification: INotification,
  ): Observable<INotification[]> {
    const updatedNotifications = this.notificationsSubject.value.filter(
      (n) => n !== notification,
    );
    this.notificationsSubject.next(updatedNotifications);
    return this.notificationsSubject;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}

export enum NotificationType {
  ERROR = 'error',
  INFO = 'info',
}

export interface INotification {
  type: NotificationType;
  message: string;
  ttl: number;
}
